import { render } from "./PackageList.vue?vue&type=template&id=890bfc4e&ts=true"
import script from "./PackageList.vue?vue&type=script&lang=ts"
export * from "./PackageList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__